export const billStatusList: {
  [key: string]: string
} = {
  "1": "Open",
  "2": "Closed",
  "3": "Credit",
  "": ""
}